module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"close":"Schliessen"},"fr":{"close":"Fermer"},"it":{"close":"Chiudere"}}')
  delete Component.options._Ctor
}
